// @flow
import FlagHoc from './FlagHoc';

export default FlagHoc;
